import React, { useEffect, useState, useCallback } from 'react';
import Loader from './components/AgendaContent/Loader';

import { today, dbDateToTimestamp, dbDateToExactTimestamp } from './utils/helpers';
import Filter from './Filter';

const App = ({ config, rootElement }) => {

	//state reflecting data and filtered data
	const [eventFeed, setEventFeed] = useState(null); //source data
	const [fetching, setFetching] = useState(true);

	//params available in dropdown for filter
	const [availableLocations, setAvailableLocations] = useState([]); //city
	const [availableDates, setAvailableDates] = useState([]);
	const [availableDatesMonths, setAvailableDatesMonths] = useState([]);
	const [availableProductions, setAvailableProductions] = useState([]);
	const [availableCategories, setAvailableCategories] = useState([]); //Soort voorstelling filter

	/**
	 * @description	Fetching feed
	 */
	async function fetchData() {
		const response = await fetch('/event_feed_json');
		if (!response.ok) {
			const message = `An error has occured: ${response.status}`;
    		throw new Error(message);
		}
		const data = await response.json();
		return data;
	};

  	/**
	 * @description	Retrieves available parameters for filtering from the feed + sets the state
	 * 					And adds a js date to the feed data
	 */
	const parseEventData = useCallback((data) => {
		const dataCopy = structuredClone(data);
		const allShowDays = [today];
		const allShowMonths = [];
		let daysCount = 1;
		let subsequentDay = new Date();
		while (config.minimum_days_in_filter && daysCount <= config.minimum_days_in_filter) {
			subsequentDay.setDate(subsequentDay.getDate() + 1);
			allShowDays.push(+new Date(subsequentDay.getFullYear(), subsequentDay.getMonth(), subsequentDay.getDate()));
			daysCount++;
		}
		const allLocations = [];
		const allProductions = [];
		const allCategories = [];
		const parsedData = [];

		Object.values(dataCopy).forEach((event) => {
			if (event?.times && event.times.length > 0) {
				event.times.map((show) => {

					if ( show?.location ) {
						!allLocations.some(location => Object.keys(location)[0] === Object.keys(show.location)[0]) && allLocations.push(show.location);
					}

					if ( show?.type ) {
						!allCategories.some(category => Object.keys(category)[0] === Object.keys(show.type)[0]) && allCategories.push(show.type);
					}

					const timestamp = dbDateToTimestamp(show.program_start);
					allShowDays.indexOf(timestamp) === -1 && allShowDays.push(timestamp);
					show.date = timestamp;
					const timestampMonth = dbDateToExactTimestamp(`${show.program_start.slice(0, 4)}${show.program_start.slice(4, 6) + 1}000000`);
					allShowMonths.indexOf(timestampMonth) === -1 && allShowMonths.push(timestampMonth);
					return show;
				});
			}

			!allProductions.some(production => Object.keys(production)[0] === event.post_id) && allProductions.push({
				[event.post_id]: event.title
			});

			parsedData.push(event);
		});

		setAvailableLocations(allLocations);
		setAvailableDates(allShowDays.sort((a, b) => a - b));
		setAvailableDatesMonths(allShowMonths.sort((a, b) => a - b));
		setAvailableProductions(allProductions);
		setAvailableCategories(allCategories);

		return parsedData;
	}, [config]);

	useEffect(() => {
		fetchData().then((data) => {
			setEventFeed(parseEventData(data.events));
			setFetching(false);
		});
	}, []);

  	if (fetching) return (
		<div className="loader__container--agenda">
			<Loader />
		</div>
	);

	return (
		<Filter
			config={config}
			eventFeed={eventFeed}
			availableLocations={availableLocations}
			availableDates={availableDates}
			availableDatesMonths={availableDatesMonths}
			availableProductions={availableProductions}
			availableCategories={availableCategories}
			rootElement={rootElement}
		/>
	);
};

export default App;
